export default "__VITE_ASSET__4fee5b50__"